var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOnboarding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.634 3.9h-13.3v18.667h13.3V3.9z",
    fill: "#FFBF3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.034 3.9L9.3 2.534c.034-.1.134-.2.234-.2h4.933c.1 0 .2.066.233.2l.267 1.366H9.034z",
    fill: "#0C0A0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 4.967H6.3V21.5h11.4V4.967z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.823 19.484c.611-.205.964-.796.788-1.32-.176-.523-.814-.781-1.425-.576-.61.206-.963.796-.787 1.32.176.523.814.781 1.424.576zM11.3 17.867h5.366M11.267 19.167c.666-.1 1.4-.167 2.233-.167.867 0 1.667.067 2.333.167M8.823 14.483c.611-.205.964-.796.788-1.32-.176-.523-.814-.78-1.425-.575-.61.205-.963.796-.787 1.32.176.523.814.78 1.424.575zM11.3 12.867h5.366M11.267 14.167c.666-.1 1.4-.167 2.233-.167.867 0 1.667.067 2.333.167M8.823 9.483c.611-.205.964-.796.788-1.32-.176-.523-.814-.78-1.425-.575-.61.205-.963.796-.787 1.32.176.523.814.78 1.424.575zM11.3 7.867h5.366M11.267 9.167c.666-.1 1.4-.167 2.233-.167.867 0 1.667.067 2.333.167",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 7.433l1.2 1.2 2.133-2.666",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgOnboarding;